module.exports = __webpack_public_path__ + "img/hush-naidoo-jade-photography-yo01Z-9HQAw-unsplash.125c4dca.jpg";